/* ============================================================================
   ag-quick-add.js
   Extracted from sections/ag-quick-add.liquid on 2026-04-16
   Two IIFEs: (1) global .ag-card__size ATC handler — runs on every page
              (2) quick-add modal open/render/close — only if modal in DOM
   Currency symbol read from modal's data-currency-symbol attribute.
   ============================================================================ */

/* --- Global .ag-card__size ATC click handler (runs site-wide) --- */
/* === INLINE SIZE — add to cart on click (global — works on all pages) === */
(function() {
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.ag-card__size:not(.ag-card__size--oos)');
    if (!sizeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = sizeBtn.dataset.variantId;
    if (!variantId) return;
    sizeBtn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      sizeBtn.textContent = '✓';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      /* Cart drawer / pre-cart modal handled by global interceptor */
      setTimeout(function() {
        var original = sizeBtn.dataset.originalText;
        if (original) sizeBtn.textContent = original;
      }, 1500);
    })
    .catch(function() { sizeBtn.textContent = '✗'; });
  }, true);
  document.querySelectorAll('.ag-card__size').forEach(function(btn) {
    btn.dataset.originalText = btn.textContent;
  });
})();

/* --- Quick-add modal open/render/close --- */
(function() {
  'use strict';
  var modal = document.getElementById('agQuickAddModal');
  if (!modal) return;
  var currencySymbol = modal.dataset.currencySymbol || '£';

  var els = {
    loading: modal.querySelector('.ag-qa-loading'),
    product: modal.querySelector('.ag-qa-product'),
    slides: modal.querySelector('.ag-qa-slides'),
    arrows: modal.querySelector('.ag-qa-arrows'),
    counter: modal.querySelector('.ag-qa-counter'),
    counterCurrent: modal.querySelector('[data-qa-current]'),
    counterTotal: modal.querySelector('[data-qa-total]'),
    title: modal.querySelector('.ag-qa-title'),
    price: modal.querySelector('.ag-qa-price'),
    priceCompare: modal.querySelector('.ag-qa-price-compare'),
    discount: modal.querySelector('.ag-qa-discount'),
    colourSection: modal.querySelector('.ag-qa-colour-section'),
    colourValue: modal.querySelector('.ag-qa-colour-value'),
    swatches: modal.querySelector('.ag-qa-swatches'),
    moreLink: modal.querySelector('.ag-qa-more-link'),
    sizesWrap: modal.querySelector('.ag-qa-sizes-wrap'),
    sizes: modal.querySelector('.ag-qa-sizes'),
    modelWears: modal.querySelector('.ag-qa-model-wears'),
    addBtn: modal.querySelector('.ag-qa-add'),
    addText: modal.querySelector('.ag-qa-add-text'),
    viewLink: modal.querySelector('.ag-qa-view')
  };

  var selectedVariantId = null;
  var currentSlide = 0;
  var slideCount = 0;

  function money(cents) {
    var amount = cents / 100;
    if (amount % 1 === 0) return currencySymbol + amount.toFixed(0);
    return currencySymbol + amount.toFixed(2);
  }

  /* ── Image carousel with counter ── */
  function isMobile() { return window.innerWidth <= 750; }

  function goToSlide(idx) {
    if (isMobile()) {
      /* Mobile: 2-up, translateX on container */
      var maxIdx = Math.max(0, slideCount - 2);
      if (idx < 0) idx = 0;
      if (idx > maxIdx) idx = maxIdx;
      currentSlide = idx;
      els.slides.style.transform = 'translateX(-' + (idx * 50) + '%)';
      /* Keep all slides visible on mobile */
      els.slides.querySelectorAll('.ag-qa-slide').forEach(function(s) {
        s.classList.add('is-active');
      });
    } else {
      /* Desktop: fade single slide */
      if (idx < 0) idx = slideCount - 1;
      if (idx >= slideCount) idx = 0;
      currentSlide = idx;
      els.slides.style.transform = '';
      els.slides.querySelectorAll('.ag-qa-slide').forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
    }
    els.counterCurrent.textContent = currentSlide + 1;
  }

  modal.querySelector('.ag-qa-prev').addEventListener('click', function() {
    goToSlide(currentSlide - (isMobile() ? 2 : 1));
  });
  modal.querySelector('.ag-qa-next').addEventListener('click', function() {
    goToSlide(currentSlide + (isMobile() ? 2 : 1));
  });

  /* ── Touch swipe for mobile ── */
  var touchStartX = 0;
  var touchDeltaX = 0;
  var isSwiping = false;

  var imagesEl = modal.querySelector('.ag-qa-images');
  imagesEl.addEventListener('touchstart', function(e) {
    if (!isMobile()) return;
    touchStartX = e.touches[0].clientX;
    touchDeltaX = 0;
    isSwiping = true;
    els.slides.style.transition = 'none';
  }, { passive: true });

  imagesEl.addEventListener('touchmove', function(e) {
    if (!isSwiping) return;
    touchDeltaX = e.touches[0].clientX - touchStartX;
    var baseOffset = -(currentSlide * 50);
    var dragPct = (touchDeltaX / imagesEl.offsetWidth) * 100;
    els.slides.style.transform = 'translateX(' + (baseOffset + dragPct) + '%)';
  }, { passive: true });

  imagesEl.addEventListener('touchend', function() {
    if (!isSwiping) return;
    isSwiping = false;
    els.slides.style.transition = 'transform 0.3s ease';
    var threshold = imagesEl.offsetWidth * 0.15;
    if (touchDeltaX < -threshold) {
      goToSlide(currentSlide + 2);
    } else if (touchDeltaX > threshold) {
      goToSlide(currentSlide - 2);
    } else {
      goToSlide(currentSlide);
    }
  });

  function render(product) {
    selectedVariantId = null;
    currentSlide = 0;

    /* Images — build carousel */
    els.slides.innerHTML = '';
    els.slides.style.transform = '';
    var images = product.images || [];
    slideCount = images.length;
    var mobile = isMobile();
    for (var i = 0; i < slideCount; i++) {
      var slide = document.createElement('div');
      /* Mobile: all slides visible in flex row. Desktop: only first active */
      slide.className = 'ag-qa-slide' + (mobile || i === 0 ? ' is-active' : '');
      slide.innerHTML = '<img class="ag-qa-img" src="' + images[i] + '" alt="' + (product.title || '') + '">';
      els.slides.appendChild(slide);
    }
    els.arrows.style.display = slideCount > 1 ? 'flex' : 'none';
    /* Counter */
    if (slideCount > 1) {
      els.counter.style.display = 'block';
      els.counterCurrent.textContent = '1';
      els.counterTotal.textContent = slideCount;
    } else {
      els.counter.style.display = 'none';
    }

    /* Title */
    els.title.textContent = product.title;

    /* Price + discount % */
    var p = product.price;
    var cp = product.compare_at_price;
    els.price.textContent = money(p);
    els.price.className = 'ag-qa-price' + (cp && cp > p ? ' ag-qa-price--sale' : '');
    els.priceCompare.textContent = cp && cp > p ? money(cp) : '';
    els.priceCompare.style.display = cp && cp > p ? 'block' : 'none';
    if (cp && cp > p) {
      var pct = Math.round((cp - p) / cp * 100);
      els.discount.textContent = '[-' + pct + '%]';
      els.discount.style.display = 'block';
    } else {
      els.discount.style.display = 'none';
    }

    /* Colour — find option index */
    var colourIdx = -1;
    for (var c = 0; c < product.options.length; c++) {
      var opt = (product.options[c].name || product.options[c]).toLowerCase();
      if (opt === 'color' || opt === 'colour') { colourIdx = c; break; }
    }

    if (colourIdx !== -1 && product.variants[0]) {
      var colourVal = product.variants[0].options[colourIdx];
      els.colourValue.textContent = colourVal;

      /* Portrait swatches — fetch from PDP page where Liquid renders metafield swatches */
      els.swatches.innerHTML = '';
      els.colourSection.style.display = 'block';

      fetch('/products/' + product.handle)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var swatchEls = doc.querySelectorAll('#more-colors .image_swatch');
          var swatchLinks = doc.querySelectorAll('#more-colors .swatch-img');

          if (swatchEls.length > 0) {
            els.swatches.innerHTML = '';
            swatchEls.forEach(function(img, idx) {
              var sw = document.createElement('div');
              sw.className = 'ag-qa-swatch';
              sw.style.backgroundImage = "url('" + img.src + "')";
              var parentLink = swatchLinks[idx];
              var title = parentLink ? parentLink.getAttribute('title') : '';
              sw.title = title;

              /* Highlight the current product's swatch */
              var parentLi = img.closest('.HorizontalList__Item');
              if (parentLi && parentLi.classList.contains('active')) {
                sw.classList.add('is-active');
              }

              /* Click swatch → smooth switch to sibling product */
              if (parentLink) {
                var href = parentLink.getAttribute('href');
                sw.addEventListener('click', function() {
                  var siblingHandle = href.split('/products/')[1];
                  if (siblingHandle) {
                    siblingHandle = siblingHandle.split('?')[0].split('#')[0];
                    switchProduct(siblingHandle);
                  }
                });
              }
              els.swatches.appendChild(sw);
            });

            if (swatchEls.length > 4) {
              els.moreLink.textContent = 'See all ' + swatchEls.length + ' colours';
              els.moreLink.href = '/products/' + product.handle;
              els.moreLink.style.display = 'inline-block';
            } else {
              els.moreLink.style.display = 'none';
            }
          } else {
            /* No sibling swatches — show single swatch from featured image */
            var sw = document.createElement('div');
            sw.className = 'ag-qa-swatch is-active';
            sw.style.backgroundImage = "url('" + (images[0] || '') + "')";
            sw.title = colourVal;
            els.swatches.appendChild(sw);
            els.moreLink.style.display = 'none';
          }
        })
        .catch(function() {
          /* Fallback — single swatch from product image */
          var sw = document.createElement('div');
          sw.className = 'ag-qa-swatch is-active';
          sw.style.backgroundImage = "url('" + (images[0] || '') + "')";
          sw.title = colourVal;
          els.swatches.appendChild(sw);
          els.moreLink.style.display = 'none';
        });
    } else {
      els.colourSection.style.display = 'none';
    }

    /* Sizes */
    els.sizes.innerHTML = '';
    var sizeIdx = -1;
    for (var s = 0; s < product.options.length; s++) {
      var o = (product.options[s].name || product.options[s]).toLowerCase();
      if (o === 'size' || o === 'sizes') { sizeIdx = s; break; }
    }

    if (sizeIdx !== -1) {
      els.sizesWrap.style.display = 'block';
      var seen = {};
      var sizeList = [];
      product.variants.forEach(function(v) {
        var sv = v.options[sizeIdx];
        if (!seen[sv]) {
          seen[sv] = true;
          sizeList.push({ value: sv, available: v.available, id: v.id, price: v.price });
        } else if (v.available) {
          var existing = sizeList.find(function(x) { return x.value === sv; });
          if (existing) { existing.available = true; existing.id = v.id; existing.price = v.price; }
        }
      });

      sizeList.forEach(function(sz) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ag-qa-size' + (!sz.available ? ' is-unavailable' : '');
        btn.textContent = sz.value;
        if (sz.available) {
          btn.addEventListener('click', function() {
            els.sizes.querySelectorAll('.ag-qa-size').forEach(function(b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            selectedVariantId = sz.id;
            els.addBtn.disabled = false;
            els.addText.textContent = 'ADD TO BAG';
          });
        }
        els.sizes.appendChild(btn);
      });

      /* Auto-select first available size */
      var firstAvailable = els.sizes.querySelector('.ag-qa-size:not(.is-unavailable)');
      if (firstAvailable) firstAvailable.click();
    } else {
      els.sizesWrap.style.display = 'none';
      if (product.variants.length === 1) {
        selectedVariantId = product.variants[0].id;
        els.addBtn.disabled = !product.variants[0].available;
        els.addText.textContent = product.variants[0].available ? 'ADD TO BAG' : 'SOLD OUT';
      }
    }

    /* Model wears — check metafield or tags */
    var modelWears = '';
    if (product.metafields && product.metafields.custom && product.metafields.custom.model_wears) {
      modelWears = product.metafields.custom.model_wears;
    } else {
      /* Fallback: check tags for model_wears: prefix */
      (product.tags || []).forEach(function(tag) {
        if (tag.toLowerCase().indexOf('model_wears:') === 0) {
          modelWears = tag.substring(12).trim();
        }
      });
    }
    if (modelWears) {
      els.modelWears.textContent = modelWears;
      els.modelWears.classList.add('is-visible');
    } else {
      els.modelWears.classList.remove('is-visible');
    }

    /* View link */
    els.viewLink.href = '/products/' + product.handle;

    /* Show */
    els.loading.style.display = 'none';
    els.product.classList.add('is-loaded');
  }

  function open(handle) {
    els.loading.style.display = 'flex';
    els.product.classList.remove('is-loaded');
    els.product.classList.remove('is-switching');
    els.addBtn.disabled = true;
    els.addText.textContent = 'ADD TO BAG';
    selectedVariantId = null;

    modal.classList.add('is-open');
    document.body.classList.add('ag-qa-open');

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) { render(product); })
      .catch(function(err) {
        console.error('[ag-quick-add]', err);
        els.loading.innerHTML = '<div class="ag-qa-loader"></div>';
      });
  }

  /* Smooth swatch switch — no teardown, just fade and swap */
  function switchProduct(handle) {
    els.product.classList.add('is-switching');
    selectedVariantId = null;
    els.addBtn.disabled = true;
    els.addText.textContent = 'ADD TO BAG';

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        render(product);
        els.product.classList.remove('is-switching');
      })
      .catch(function(err) {
        console.error('[ag-quick-add] switch error', err);
        els.product.classList.remove('is-switching');
      });
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('ag-qa-open');
  }

  /* ── Add to cart — no green flash, stays black ── */
  els.addBtn.addEventListener('click', function() {
    if (!selectedVariantId) return;
    els.addBtn.disabled = true;
    els.addText.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(selectedVariantId), quantity: 1 }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      els.addText.textContent = 'ADDED ✓';
      setTimeout(function() {
        close();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        /* Cart drawer / pre-cart modal handled by global interceptor */
      }, 600);
    })
    .catch(function() {
      els.addText.textContent = 'ERROR — TRY AGAIN';
      els.addBtn.disabled = false;
    });
  });

  /* Close handlers */
  modal.querySelectorAll('[data-ag-qa-close]').forEach(function(el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });

  /* Global click handler for [data-ag-quick-add] buttons */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-ag-quick-add]');
    if (btn) {
      /* Skip if inside pre-cart modal or cart drawer — those have their own size strip handler */
      if (btn.closest('#ag-precart-modal') || btn.closest('#sidebar-cart')) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn.dataset.agQuickAdd);
    }
  }, true);

  window.agQuickAdd = { open: open, close: close, switchProduct: switchProduct };
})();
